import moment from "moment";

/**
 * Safari fix for the Home booking calendar losing all of its villa colours.
 *
 * @impulsiveweb/react-booking-calendar builds its month-end boundary as:
 *
 *     moment(startDate.format("YYYY-MM-DD") + "  23:59:59")
 *
 * — with TWO spaces (index.js:2124 and :2307). moment's ISO parser rejects a
 * double separator, so it falls back to `new Date(string)` and warns that this
 * is "not reliable across all browsers and versions". It isn't:
 *
 *     new Date("2026-08-01  23:59:59")
 *       V8 (Chrome/Node) -> Sat Aug 01 2026 23:59:59
 *       JavaScriptCore (Safari) -> Invalid Date
 *
 * Every `isSameOrBefore(endDay)` / `isBefore(startDate)` range check against an
 * Invalid Date returns false, so in Safari no booking falls inside the displayed
 * month, no `.cld_date_bg` bars render, and the calendar shows bare dates.
 *
 * The library is at its latest published version (1.0.4) with no fix upstream,
 * and the string is built internally, so it can't be avoided from our side.
 *
 * This hook replaces moment's fallback with the same `new Date()` call after
 * collapsing runs of whitespace. It only ever runs on input moment has ALREADY
 * given up on and was about to hand to `new Date()` anyway — anything moment can
 * parse natively never reaches here — so normalising whitespace can only make
 * such a string more parseable, never less.
 */
export const installMomentDateFallback = () => {
  (moment as any).createFromInputFallback = (config: any) => {
    const input =
      typeof config._i === "string"
        ? config._i.trim().replace(/\s+/g, " ")
        : config._i;
    // Mirrors moment's own default (moment.js:2622), minus the deprecation warning.
    config._d = new Date(input + (config._useUTC ? " UTC" : ""));
  };
};
